<div class="cumulative-selector-overlay">
    <div class="cumulative-selector-modal">
        <div class="modal-header">
            <h2>Select Cumulative Period</h2>
            <ion-button fill="clear" (click)="cancel()">
                <ion-icon name="close"></ion-icon>
            </ion-button>
        </div>

        <div class="modal-content">
            <!-- Loading state -->
            <div *ngIf="loading" class="loading-state">
                <ion-spinner name="crescent"></ion-spinner>
                <p>Loading available periods...</p>
            </div>

            <!-- Error message -->
            <div *ngIf="errorMessage" class="error-message">
                <ion-icon name="warning-outline"></ion-icon>
                <span>{{ errorMessage }}</span>
            </div>

            <!-- Available periods list -->
            <div *ngIf="!loading && availablePeriods.length > 0" class="periods-section">
                <h3>Available Cumulative Periods</h3>
                <ion-list>
                    <ng-container *ngFor="let period of availablePeriods">
                        <!-- Period header (click to expand) -->
                        <ion-item button (click)="toggleExpand(period)" [disabled]="creating">
                            <ion-icon [name]="isExpanded(period) ? 'chevron-down' : 'chevron-forward'" slot="start"></ion-icon>
                            <ion-label>
                                <h2>{{ formatWindow(period.windowInMinutes) }}</h2>
                                <p>{{ formatPeriod(period) }}</p>
                                <p class="count-info">{{ period.count }} cumulative(s) - click to expand</p>
                            </ion-label>
                        </ion-item>

                        <!-- Expanded: individual cumulatives -->
                        <div *ngIf="isExpanded(period)" class="expanded-items">
                            <ion-spinner *ngIf="isLoadingExpanded(period)" name="crescent"></ion-spinner>
                            <ion-list *ngIf="!isLoadingExpanded(period)" class="nested-list">
                                <ion-item *ngFor="let item of getExpandedItems(period)"
                                          button
                                          (click)="selectIndividualCumulative(item)"
                                          class="nested-item"
                                          [disabled]="creating">
                                    <ion-icon name="time-outline" slot="start"></ion-icon>
                                    <ion-label>
                                        <h3>{{ getItemPeriodBegin(item) | date:'HH:mm' }} - {{ item.date | date:'HH:mm' }}</h3>
                                    </ion-label>
                                    <ion-icon name="chevron-forward" slot="end"></ion-icon>
                                </ion-item>
                                <ion-item *ngIf="getExpandedItems(period).length === 0" class="nested-item">
                                    <ion-label>
                                        <p>No individual cumulatives found</p>
                                    </ion-label>
                                </ion-item>
                            </ion-list>
                        </div>
                    </ng-container>
                </ion-list>
            </div>

            <!-- No periods available -->
            <div *ngIf="!loading && availablePeriods.length === 0" class="no-periods">
                <ion-icon name="information-circle-outline"></ion-icon>
                <p>No cumulative periods available yet.</p>
            </div>

            <!-- Create new section (admin only) -->
            <div *ngIf="!loading && isAdmin" class="create-section">
                <h3>Create New Cumulative</h3>
                <div class="create-info">
                    <p>
                        <strong>Period:</strong>
                        {{ currentPeriodBegin?.toLocaleString() }} → {{ currentPeriodEnd?.toLocaleString() }}
                    </p>
                    <p>
                        <strong>Window:</strong> {{ formatWindow(currentWindowMinutes) }}
                    </p>
                    <p *ngIf="baseCumulatives" class="coverage-info"
                       [class.coverage-ok]="coveragePercent >= 100"
                       [class.coverage-warn]="coveragePercent > 0 && coveragePercent < 100"
                       [class.coverage-error]="coveragePercent === 0">
                        <ion-icon [name]="coveragePercent >= 100 ? 'checkmark-circle' : 'alert-circle'"></ion-icon>
                        Base data coverage: {{ coveragePercent }}%
                    </p>
                    <p *ngIf="!baseCumulatives" class="coverage-error">
                        <ion-icon name="alert-circle"></ion-icon>
                        No base cumulatives available
                    </p>
                </div>

                <!-- Creation progress -->
                <div *ngIf="creating" class="creation-progress">
                    <ion-spinner name="crescent"></ion-spinner>
                    <span>{{ creationProgress }}</span>
                </div>

                <ion-button [disabled]="!canCreateNew || creating"
                            expand="block"
                            (click)="createNewPeriod()">
                    <ion-icon name="add-circle-outline" slot="start"></ion-icon>
                    Create {{ formatWindow(currentWindowMinutes) }} Cumulative
                </ion-button>

                <p *ngIf="!canCreateNew && !creating" class="create-hint">
                    Create is disabled because no base 5-min cumulatives exist for the selected period.
                </p>
            </div>
        </div>

        <div class="modal-footer">
            <ion-button fill="outline" (click)="cancel()" [disabled]="creating">
                Cancel
            </ion-button>
        </div>
    </div>
</div>
